// TREVISSO — scripts propios (vanilla JS, sin librerias externas)

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  els.forEach(function (el, i) {
    if (!el.style.getPropertyValue('--mt-stagger')) {
      el.style.setProperty('--mt-stagger', el.dataset.stagger || (i % 6));
    }
  });
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var nums = document.querySelectorAll('.mt-cifra__num[data-hasta]');
  if (!nums.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var hasta = parseFloat(el.dataset.hasta) || 0;
      var decimales = el.dataset.decimales === '1';
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var p = Math.min((ts - inicio) / dur, 1);
        var valor = hasta * (1 - Math.pow(1 - p, 3));
        el.textContent = decimales ? valor.toFixed(1) : Math.round(valor);
        if (p < 1) requestAnimationFrame(paso);
        else el.textContent = decimales ? hasta.toFixed(1) : hasta;
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  nums.forEach(function (el) { obs.observe(el); });
}

function initAcabadoSwap() {
  document.querySelectorAll('.mt-acabado').forEach(function (card) {
    var base = card.querySelector('.mt-acabado__img--base');
    var alt = card.querySelector('.mt-acabado__img--alt');
    if (!base || !alt) return;
    card.addEventListener('touchstart', function () {
      base.style.opacity = 0;
      alt.style.opacity = 1;
    }, { passive: true });
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelectorAll('.mt-producto__principal img');
  var minis = galeria.querySelectorAll('.mt-producto__miniatura');

  function mostrarIndice(idx) {
    minis.forEach(function (m) { m.classList.toggle('mt-activa', m.dataset.indice === idx); });
    principal.forEach(function (img) { img.classList.toggle('mt-activa', img.dataset.indice === idx); });
  }

  function filtrarPorGrupo(grupo) {
    var primerVisible = null;
    minis.forEach(function (mini) {
      var propio = mini.dataset.grupo === grupo || mini.dataset.grupo === 'general';
      mini.style.display = propio ? '' : 'none';
      if (propio && !primerVisible) primerVisible = mini;
    });
    principal.forEach(function (img) {
      var propio = img.dataset.grupo === grupo || img.dataset.grupo === 'general';
      img.style.display = propio ? '' : 'none';
    });
    if (primerVisible) mostrarIndice(primerVisible.dataset.indice);
  }

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () { mostrarIndice(mini.dataset.indice); });
  });

  galeria.filtrarPorGrupo = filtrarPorGrupo;

  if (galeria.dataset.grupoInicial) filtrarPorGrupo(galeria.dataset.grupoInicial);
}

function initAcordeon() {
  document.querySelectorAll('.mt-acordeon__item').forEach(function (item) {
    var cabecera = item.querySelector('.mt-acordeon__cabecera');
    var panel = item.querySelector('.mt-acordeon__panel');
    if (!cabecera || !panel) return;
    cabecera.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-abierto');
      item.parentElement.querySelectorAll('.mt-acordeon__item').forEach(function (otro) {
        otro.classList.remove('mt-abierto');
        otro.querySelector('.mt-acordeon__panel').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mt-abierto');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

function initSelectorVariantes() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var datos = form.querySelector('[data-mt-variantes]');
  if (!datos) return;
  var variantes;
  try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }

  var idInput = form.querySelector('input[name="id"]');
  var boton = form.querySelector('[data-mt-submit]');
  var botonComprarAhora = document.querySelector('[data-mt-comprar-ahora]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var tachadoEl = document.querySelector('[data-mt-precio-tachado]');
  var descuentoEl = document.querySelector('[data-mt-precio-descuento]');
  var disponibilidadEl = document.querySelector('[data-mt-disponibilidad]');
  var nodosOpcion = Array.prototype.slice.call(document.querySelectorAll('[data-mt-posicion]'))
    .sort(function (a, b) { return (a.dataset.mtPosicion | 0) - (b.dataset.mtPosicion | 0); });

  function seleccionActual() {
    return nodosOpcion.map(function (nodo) {
      if (nodo.hasAttribute('data-mt-opcion-fija')) return nodo.dataset.valor;
      var activo = nodo.querySelector('.mt-swatch.mt-activa');
      return activo ? activo.dataset.valor : null;
    });
  }

  function coincide(v, sel) {
    for (var i = 0; i < sel.length; i++) {
      if (sel[i] != null && v['option' + (i + 1)] !== sel[i]) return false;
    }
    return true;
  }

  function formatearDinero(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }

  function actualizar() {
    var sel = seleccionActual();
    var variante = variantes.find(function (v) { return coincide(v, sel); });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = formatearDinero(variante.price);
    if (tachadoEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        tachadoEl.textContent = formatearDinero(variante.compare_at_price);
        tachadoEl.style.display = '';
        if (descuentoEl) {
          var pct = Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100);
          descuentoEl.textContent = '-' + pct + '%';
          descuentoEl.style.display = '';
        }
      } else {
        tachadoEl.style.display = 'none';
        if (descuentoEl) descuentoEl.style.display = 'none';
      }
    }
    if (boton) boton.disabled = !variante.available;
    if (botonComprarAhora) botonComprarAhora.disabled = !variante.available;
    if (disponibilidadEl) {
      disponibilidadEl.textContent = variante.available ? disponibilidadEl.dataset.disponible : disponibilidadEl.dataset.agotado;
      disponibilidadEl.classList.toggle('mt-agotado', !variante.available);
    }
    var galeria = document.querySelector('[data-mt-galeria]');
    if (galeria && galeria.filtrarPorGrupo && variante.option1) {
      galeria.filtrarPorGrupo(variante.option1);
    }
  }

  nodosOpcion.forEach(function (nodo) {
    if (nodo.hasAttribute('data-mt-opcion-fija')) return;
    nodo.querySelectorAll('.mt-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        nodo.querySelectorAll('.mt-swatch').forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
        actualizar();
      });
    });
  });

  actualizar();
}

function initCuentaAtras() {
  var els = document.querySelectorAll('.mt-countdown[data-hasta]');
  if (!els.length) return;
  function pad(n) { return String(n).padStart(2, '0'); }
  function actualizar() {
    els.forEach(function (el) {
      var destino = new Date(el.dataset.hasta).getTime();
      var ahora = Date.now();
      var restante = destino - ahora;
      if (isNaN(destino) || restante <= 0) {
        el.textContent = '';
        return;
      }
      var dias = Math.floor(restante / 86400000);
      var horas = Math.floor((restante % 86400000) / 3600000);
      var min = Math.floor((restante % 3600000) / 60000);
      var seg = Math.floor((restante % 60000) / 1000);
      el.textContent = ' · ' + dias + 'd ' + pad(horas) + ':' + pad(min) + ':' + pad(seg);
    });
  }
  actualizar();
  setInterval(actualizar, 1000);
}

function initRelojAnimado() {
  var horaEl = document.querySelector('.mt-reloj-hora');
  var minEl = document.querySelector('.mt-reloj-minuto');
  var segEl = document.querySelector('.mt-reloj-segundo');
  if (!horaEl && !minEl) return;

  function actualizar() {
    var ahora = new Date();
    var h = ahora.getHours();
    var m = ahora.getMinutes();
    var s = ahora.getSeconds();
    var anguloHora = ((h % 12) + m / 60) * 30;
    var anguloMinuto = (m + s / 60) * 6;
    var anguloSegundo = s * 6;
    if (horaEl) horaEl.style.transform = 'rotate(' + anguloHora + 'deg)';
    if (minEl) minEl.style.transform = 'rotate(' + anguloMinuto + 'deg)';
    if (segEl) segEl.style.transform = 'rotate(' + anguloSegundo + 'deg)';
  }

  actualizar();
  setInterval(actualizar, 1000);
}

function initComprarAhora() {
  var boton = document.querySelector('[data-mt-comprar-ahora]');
  var form = document.querySelector('[data-mt-producto-form]');
  if (!boton || !form) return;
  boton.addEventListener('click', function () {
    if (boton.disabled) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    var textoOriginal = boton.textContent;
    boton.disabled = true;
    boton.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        boton.disabled = false;
        boton.textContent = textoOriginal;
        form.submit();
      });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initAcabadoSwap();
  initGaleriaProducto();
  initAcordeon();
  initSelectorVariantes();
  initComprarAhora();
  initCuentaAtras();
  initRelojAnimado();
});
